// Client for the "Suivi des marchés par bénéficiaire" (market-tracking) page.
// Thin wrappers over the shared dataProvider so the page stays declarative.
// The backend scopes beneficiaries (member role) to their own data server-side,
// so no client-side scoping is needed here.

function getRows(dataProvider, filters, range) {
  return dataProvider.getList(
    'market-tracking',
    { filters, range },
    undefined,
    false
  )
}

function getKpis(dataProvider, filters) {
  return dataProvider.getList(
    'market-tracking/kpis',
    { filters },
    undefined,
    false
  )
}

// Exports go through the async pipeline (ExportContext.startExport with the
// `market-tracking-*` types), so no direct download URL is built here.

export default {
  getRows,
  getKpis,
}
